import { LoginResponse, AuthRequest, AuthResponse, LogoutResponse } from '@/types/auth';
import { api } from './index';

class AuthService {
  /**
   * Login to get authentication URL
   * GET /v3/login
   */
  async login(): Promise<LoginResponse> {
    try {
      const options = import.meta.env.MODE === 'development' ? { params: { local: true } } : {};
      const response = await api.get<LoginResponse>('/login', options);
      return response.data;
    } catch (error) {
      console.error('Error during login:', error);
      throw error;
    }
  }

  /**
   * Exchange authorization code for access token
   * POST /v3/auth
   */
  async auth(authData: AuthRequest): Promise<AuthResponse> {
    try {
      const response = await api.post<AuthResponse>('/auth', authData);
      return response.data;
    } catch (error) {
      console.error('Error during authentication:', error);
      throw error;
    }
  }

  /**
   * Logout from the API
   * GET /v3/logout
   */
  async logout(): Promise<LogoutResponse> {
    try {
      const response = await api.get<LogoutResponse>('/logout');
      return response.data;
    } catch (error) {
      console.error('Error during logout:', error);
      throw error;
    }
  }
}

export const authService = new AuthService();
